import jVPList from '@/views/visual-programming/jVPList';
import jVPMain from '@/views/visual-programming/jVPMain';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/visual-programming',
    name: 'jVPList',
    component: jVPList,
    meta: {
      title: 'Visual Programming',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/visual-programming/:automationId',
    name: 'jVPMain',
    component: jVPMain,
    meta: {
      title: 'Visual Programming',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterVP.js